module.exports = __webpack_public_path__ + "static/media/multipago.d5ad7533.svg";